import { useMemo } from 'react'
import { useMedia } from 'react-use'
import classNames from 'classnames'

import Container from '@/components/base/Container'
import Grid from '@/components/base/Grid'
import Section from '@/components/base/Section'
import { MediaQuery } from '@/constants'

import { SectionTheme, WPImage, WPVideo } from '@/types'

type SingleVideoProps = SectionTheme & {
  videoMobile: Partial<WPVideo>
  videoDesktop: Partial<WPVideo>
  posterMobile: Partial<WPImage>
  immagineDesktop: Partial<WPImage>
  autoplay?: boolean
}

const SingleVideo = ({
  theme,
  autoplay,
  videoMobile,
  videoDesktop,
  posterMobile,
  immagineDesktop: posterDesktop,
  ...props
}: SingleVideoProps) => {
  const needsMobileVideo = useMedia(MediaQuery.MOBILE, true)

  const video = useMemo(
    () => (needsMobileVideo && videoMobile.url ? videoMobile : videoDesktop),
    [needsMobileVideo, videoMobile, videoDesktop]
  )
  const poster = useMemo(
    () => (needsMobileVideo ? posterMobile : posterDesktop),
    [needsMobileVideo, posterMobile, posterDesktop]
  )

  return (
    <Section theme={theme} {...props}>
      <Container>
        <Grid>
          <div className="col-span-2 md:col-span-6 lg:col-span-12">
            <span
              className={classNames(
                'aspect-h-1 aspect-w-1 relative block md:aspect-h-9 md:aspect-w-16',
                {
                  'aspect-h-9 aspect-w-16': needsMobileVideo && !videoMobile.url
                }
              )}
            >
              <video
                poster={poster.url}
                playsInline={autoplay}
                autoPlay={autoplay}
                muted={autoplay}
                controls={true}
                loop={true}
                className="h-full w-full object-cover"
              >
                <source src={video.url} type="video/mp4" />
              </video>
            </span>
          </div>
        </Grid>
      </Container>
    </Section>
  )
}

export default SingleVideo
